import React from 'react';
import OptionCatalogManager from '../components/PrimeModel/OptionCatalogManager';

export const OptionCatalogManagementPage: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <OptionCatalogManager
        visible={true}
        onClose={() => {
          // Page-level component, so onClose is a no-op
          // The catalog manager handles its own modal state internally
        }}
      />
    </div>
  );
};

